import React from 'react';
import { Calendar } from 'react-date-range';
import CloseIcon from '@mui/icons-material/Close';
import { subDays } from 'date-fns';
import 'react-date-range/dist/styles.css';
import 'react-date-range/dist/theme/default.css';

const DatePicker = ({ datestate, handledateChange, handleDateClose }) => {
  const quickRanges = {
    Today: new Date(),
    Yesterday: subDays(new Date(), 1),
  };

  const handleQuickRangeClick = (date) => {
    handledateChange([
      {
        startDate: date,
        endDate: date,
        key: 'selection',
      },
    ]);
  };

  const handleDateSelect = (date) => {
    handledateChange([
      {
        startDate: date,
        endDate: date,
        key: 'selection',
      },
    ]);
  };

  return (
    <div className="bg-white p-4 md:p-2 sm:p-2 rounded-lg shadow-lg flex gap-4">
      {/* Left Panel: Quick Select */}
      <div className=" hidden sm:flex flex-col justify-between items-center px-2">
        <div className="flex flex-col gap-2 min-w-[120px]">
          {Object.entries(quickRanges).map(([label, date]) => (
            <button
              key={label}
              className="text-md text-[#293050] font-medium hover:underline text-start"
              onClick={() => handleQuickRangeClick(date)}
            >
              {label}
            </button>
          ))}
        </div>
        <button
          onClick={() => handleQuickRangeClick(new Date())}
          className="text-md text-[#0080FF] font-medium hover:underline text-start"
        >
          Reset
        </button>
      </div>

      {/* Right Panel: Calendar & Close */}
      <div className="flex-grow">
        <div className="flex gap-8 items-center justify-end mb-2">
          <button
            onClick={handleDateClose}
            className="bg-[#0080FF] text-white px-6 py-1 rounded-md text-xs font-medium hover:bg-[#0066cc] transition"
          >
            Apply
          </button>

          <CloseIcon
            onClick={handleDateClose}
            style={{ width: 20, color: '#ccc', cursor: 'pointer' }}
          />
        </div>
        <Calendar
          date={datestate[0]?.startDate || new Date()}
          onChange={handleDateSelect}
        />
      </div>
    </div>
  );
};

export default DatePicker;
